export const VIDEO_ZIP_REQUEST_POLL_ID =
  'app/clip-select/video-group-zip-request-poll-id';
